<div class="detail-body">
    <div class="detail-documents relevant-info">
        @if (irpfTableService.isInit()) {
            <div  class="detail-content">
                <div class="detail-content-header">
                    <span class="material-symbols-outlined custom-doc "> account_balance </span>
                    <h3>{{ 'IRPF.TITLE' | translate }}</h3>
                </div>
                <app-irpf-table />
            </div>
        }

        <app-innovation-kpis [kpis]="innovationRequestDetailService.kpis()" />
    </div>

    <app-detail-documents class="detail-documents" [detail]="innovationRequestDetailService.request" [toRemove]="documentNamesToRemove" />
</div>
